import { css, extractShadow, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  wrapper: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
  `,
  root: ({ theme }) => css`
    background-color: ${theme.colors.neutral.variant[0]};
    border-radius: 16px;
    padding: 32px 24px;
    width: 550px;
    box-shadow: ${extractShadow((s) => s.robin2)};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    text-align: center;
  `,
  iconContainer: ({ theme }) => css`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.secondary.emerald[10]};
    color: ${theme.colors.secondary.emerald[50]};
  `,
  textContainer: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
